import React from 'react'
import { ArrowUpRight } from 'lucide-react'
import { Button, Card, CardContent } from '@/shared/ui'

type FreemiumPostUpgradeCardProps = {
  moduleLabel: string
  ctaHref?: string
}

export function FreemiumPostUpgradeCard({
  moduleLabel,
  ctaHref = '/my-plans',
}: FreemiumPostUpgradeCardProps) {
  const label = moduleLabel.trim() || 'este canal'

  return (
    <Card className="relative overflow-hidden border-emerald-500/40 bg-gradient-to-r from-emerald-500/10 via-amber-500/10 to-lime-500/10">
      <CardContent className="p-4 md:p-5">
        <div className="space-y-3">
          <div className="text-lg font-semibold text-emerald-300">
            Seu plano Freemium não permite publicar posts em {label}.
          </div>
          <div className="text-sm text-foreground/80">
            No Freemium você pode acompanhar as postagens, mas a criação de posts fica bloqueada.
          </div>
        </div>

        <div className="mt-4 rounded-xl border border-white/10 bg-zinc-900 p-4">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="max-w-[560px] text-base font-semibold leading-snug text-foreground md:text-lg">
              Assine um plano para liberar a criação de posts e compartilhar suas ideias com a comunidade.
            </div>
            <div className="flex justify-start md:justify-end">
              <Button
                type="button"
                onClick={() => {
                  window.location.href = ctaHref
                }}
                className="inline-flex items-center gap-2 rounded-full bg-emerald-400 px-5 py-2 text-sm font-semibold text-black hover:bg-emerald-300"
              >
                Assinar plano
                <ArrowUpRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
